/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import styles from "../../SpecialtyPersonalStyles.module.scss"
import MobileHomesComponent from '../../components/MobileHomes/MobileHomes/MobileHomesComponent';
import metadata from './MobileHomePage.metadata.json5';
import SolidFuelHeatingComponent from '../../components/MobileHomes/SolidFuelHeating/SolidFuelHeatingComponent';
import HobbyFarmApplicationComponent from '../../components/MobileHomes/HobbyFarmApplication/HobbyFarmApplicationComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';


function MobileHomePage(props) {
    
    const {
       wizardData: submissionVM,
       updateWizardData,
       viewModelService
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('MobileHomePage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;


    const onNext = useCallback(async () => {
        const productCode = _.get(submissionVM.value, 'baseData.productCode');
        // eslint-disable-next-line security/detect-object-injection
        const lobLineName = productCode ? lineName[productCode] : "";
        const response = await updateSubmission(
            lobLineName,
            "MobileHomesPage",
            submissionVM
        );

        submissionVM.value = response;

        return submissionVM;

        },[lineName, submissionVM, updateSubmission]);

    const onSave = useCallback(async () => {
      const subVMCopy = _.clone(submissionVM)
      const productCode = _.get(subVMCopy.value, 'baseData.productCode');

      validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value, ' ')

      const lobLineName = productCode ? lineName[productCode] : '';
      await updateSubmission(lobLineName, 'MobileHomePage', subVMCopy);
                      
      return submissionVM;
    },[lineName, updateSubmission, submissionVM]);

    const addMobileHomes = useCallback(async () => {
        const mobileHomesObj = {
            tempID: EntityUtil.nextId(),
            propertyDetails: {
                isValidationReq: true
            },
            utilities: {
                isValidationReq: true
            },
            oilTank: {
                isValidationReq: true
            },
            solidFuelHeating: {
                isValidationReq: true
            },
            additionalInformation: {
                isValidationReq: true
            },
            hobbyFarmApplication: {
                isValidationReq: true
            },
            incidentalOfficeUse: {
                isValidationReq: true
            },
            scheduledArticles: {
                ScheduleArticleTable: []
            }
        };

        // eslint-disable-next-line no-unsafe-optional-chaining
        const { _xCenter, _dtoName } = submissionVM?.lobData?.perLine?.coverables?.mobileHomeCoverable?.mobileHomes;

        const mobileHomesVM = viewModelService.create(mobileHomesObj, _xCenter, _dtoName);

        submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value = submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value || []

        submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.pushElement(
            mobileHomesVM
        )

        updateWizardData(submissionVM);

    }, [submissionVM, viewModelService, updateWizardData])

    const mobileHomesOverrides = useMemo(() => {
        const mobileHomesList = _.get(submissionVM, 'lobData.perLine.coverables.mobileHomeCoverable.mobileHomes', []);
        let overrides = [];

        if (!_.isEmpty(mobileHomesList)) {
            overrides = mobileHomesList?.children.map((mobileHome, index) => ({
                [`mobileHomesComponent${index}`]: {
                    overrideProps: {
                        "@field": {
                            // apply to all fields
                            showRequired: true,
                            labelPosition: "left",
                        },
                    },
                    submissionVM,
                    updateWizardData,
                    pathUpdated: `lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.children[${index}]`,
                    mobileHomesVM : mobileHome,
                    index,
                    viewModelService
                }
            }));

            
        }

        return Object.assign({}, ...overrides);

    }, [updateWizardData, viewModelService, submissionVM]);

    const overrideProps = {
        "@field": {
            showRequired: true,
            labelPosition: breakpoint === "desktop" ? "left" : "top"
        },
        ...mobileHomesOverrides,
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            addMobileHomes
        },
        resolveComponentMap: {
            mobileHomesComponent: MobileHomesComponent,
            // riskInformation: RiskInformationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.aspects.subtreeValid

    return (
        <WizardPage 
            onNext={onNext} 
            onSave={onSave} 
            skipWhen={() => initialValidation} 
            disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

MobileHomePage.propTypes = wizardProps;
export default withViewModelService(MobileHomePage);
